<button mat-icon-button (click)="onReload()">
    <mat-icon>refresh</mat-icon>
</button>